export const STORE_CREATE_REQUEST = 'STORE_CREATE_REQUEST'
export const STORE_CREATE_SUCCESS = 'STORE_CREATE_SUCCESS'
export const STORE_CREATE_FAIL = 'STORE_CREATE_FAIL'

export const STORE_LIST_REQUEST = 'STORE_LIST_REQUEST'
export const STORE_LIST_SUCCESS = 'STORE_LIST_SUCCESS'
export const STORE_LIST_FAIL = 'STORE_LIST_FAIL'
